import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ViewBlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/viewblacklist/viewblacklistdto';
import { ViewBlacklistResponse } from 'src/com/sixdee/crbtportal/core/api/blacklist/viewblacklist/viewblacklistresponse';
import { ViewBlacklistRequestImpl } from 'src/com/sixdee/crbtportal/core/api/blacklist/viewblacklist/viewblacklistrequest';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { RemoveFromBlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/removefromblacklist/removefromblacklistdto';
import { BlacklistMemberDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/addtoblacklist/blacklistmemberdetailsdto';
import { RemoveFromBlacklistResponse } from 'src/com/sixdee/crbtportal/core/api/blacklist/removefromblacklist/removefromblacklistresponse';
import { RemoveFromBlacklistRequestImpl } from 'src/com/sixdee/crbtportal/core/api/blacklist/removefromblacklist/removefromblacklistrequest';

export interface ListBlacklistAPIModel extends APIModel
{
    viewBlackList(): void;
    deleteBlackList(memberDetailsDto:MemberDetailsDto):void;
}

export class ListBlacklistAPIModelImpl extends APIModelImpl implements ListBlacklistAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }


    deleteBlackList(memberDetailsDto:MemberDetailsDto):void
    {

        // console.log("removeBlacklistAPI() invoked ##########REMOVE BLACKLIST###############",memberDetailsDto.getMemberName());
        let removeFromBlacklistDto = new RemoveFromBlacklistDtoImpl();
        removeFromBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        removeFromBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        removeFromBlacklistDto.setChannelId(this.getContext().getUserContext().getChannelId());

        let membersDetailsDto = new BlacklistMemberDetailsDtoImpl();
        membersDetailsDto.setBPartyMsisdn(memberDetailsDto.getMsisdn());
        removeFromBlacklistDto.setMemberDetails([membersDetailsDto]);

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getRemoveFromBlacklistAPIProcessor()
        .success((removeFromBlacklistResponse: RemoveFromBlacklistResponse)=>
        {
            console.log("success() invoked ##########REMOVE BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(removeFromBlacklistResponse.getAPIFeature(), 
            removeFromBlacklistResponse.getDescription(), memberDetailsDto);
         })
        .failure((removeFromBlacklistResponse: RemoveFromBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(removeFromBlacklistResponse.getAPIFeature(), 
           removeFromBlacklistResponse.getDescription(), undefined);
         })
        .execute(new RemoveFromBlacklistRequestImpl(removeFromBlacklistDto));
    }
    viewBlackList(): void
    {
        console.log("viewBlacklistAPI() invoked ##########VIEW BLACKLIST###############");
        let viewBlacklistDto = new ViewBlacklistDtoImpl();
        viewBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        viewBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        viewBlacklistDto.setChannelId(this.getContext().getUserContext().getChannelId());
        viewBlacklistDto.setServiceId("1");
        viewBlacklistDto.setActivityId("4");
        viewBlacklistDto.setRbtMode("101");

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getViewBlacklistAPIProcessor()
        .success((viewBlacklistResponse: ViewBlacklistResponse)=>
        {
            console.log("success() invoked ##########VIEW BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(viewBlacklistResponse.getAPIFeature(), 
            viewBlacklistResponse.getDescription(), viewBlacklistResponse.getViewBlacklist().getMemberDetails());
         })
        .failure((viewBlacklistResponse: ViewBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(viewBlacklistResponse.getAPIFeature(), 
           viewBlacklistResponse.getDescription(), undefined);
         })
        .execute(new ViewBlacklistRequestImpl(viewBlacklistDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/blacklisting/listblacklistapimodel.tsx